module.exports = __webpack_public_path__ + "img/teacher7.4079cf7f.webp";